import { type PreQualState } from "@/stores/preQual"
import { type PreQualificationType } from "@/generated/graphql"

/*
  Functions for tracking events with Facebook Pixel.
*/

export const fbqTrackCustom = (eventName: string, eventData: object = {}) => {
  if (typeof window !== "undefined" && "fbq" in window) {
    ;(window as any).fbq("trackCustom", eventName, eventData)
  }
}

const CREDIT_GROUP = {
  "below-640": 0,
  "Below 640": 0,
  "640-670": 1,
  "640-669": 1,
  "670-690": 2,
  "670-689": 2,
  "690-749": 3,
  "690+": 3,
  "750+": 4,
  "Above 750": 4,
  undefined: null,
} as const

/*
  Facebook has rules about the kinds of data that you can share in events.
  For example, `sustainabilityScore` is really a proxy for credit score, but we
  can't share credit score because of Facebook's policy.

  https://www.facebook.com/business/help/361948878201809?id=188852726110565

  When you are adding to this group, take the linked article into account. If
  you are adding something that could fall within one of these categories, make
  sure you transform it in some way that doesn't violate Facebook's policy.
 */

export const fbqUserAttributes = (
  preQualState: PreQualState | PreQualificationType,
  user: any | undefined
) => {
  const attributesMapping = {
    email: user?.me?.email,
    propertiesFlipped: preQualState?.propertiesFlipped,
    rentalsOwned: preQualState?.rentalsOwned,
    cashAvailable: preQualState?.cashAvailable,
    borrower: preQualState?.borrower,
    // timeline: preQualState?.timeline,
    intentStatus: preQualState?.intentStatus,
    suitabilityScore: null as number | null, // A proxy for credit score

    is_qualified: preQualState?.creditScore !== "below-640", // Possibly deprecated?
  }

  if (preQualState?.creditScore) {
    attributesMapping.suitabilityScore =
      CREDIT_GROUP[preQualState?.creditScore as keyof typeof CREDIT_GROUP]
  }

  return attributesMapping
}
